import React, { useState, useEffect, useRef } from 'react';
import { Modal } from "seed/helpers"
import l from "components/util/l";
import "styles/css/util/helpers/IconPicker.css"


function IconPicker({ initialIcon, onSelectIcon = () => { } }) {

	const [filters, setFilters] = useState({
		searchTerm: "",
		selectedCategory: "all"
	});
	const [isIconPiickerOpen, setIsIconPickerOpen] = useState(false);
	const [icons, setIcons] = useState([]);
	const [filteredIcons, setFilteredIcons] = useState([]);
	const [categories, setCategories] = useState([]);
	const [selectedIcon, setSelectedIcon] = useState(null);

	useEffect(() => {
		fetch("/resources/icons/icons.json")
			.then((res) => res.json())
			.then((data) => {
				setIcons(data);
				setFilteredIcons(data);
				if (initialIcon) {
					const initialIconObj = data.find(icon => icon.class == initialIcon);
					setSelectedIcon(initialIconObj);
				}
			})
			.catch((err) => console.error("Error loading JSON:", err));

		fetch("/resources/icons/icon_categories.json")
			.then((res) => res.json())
			.then((data) => setCategories(data))
			.catch((err) => console.error("Error loading JSON:", err));
	}, []);

	useEffect(() => {
		let filtered = [...icons];
		if (filters?.selectedCategory && filters?.selectedCategory != "all") {
			filtered = filtered.filter(icon => icon.categories.includes(filters.selectedCategory));
		}
		if (filters?.searchTerm && filters?.searchTerm != "") {
			const term = filters.searchTerm.toLowerCase();
			filtered = filtered.filter(icon => {
				const inName = icon.name?.toLowerCase().includes(term);
				const inSearchTerms = Array.isArray(icon.search_terms) &&
					icon.search_terms.some(st => st.toLowerCase().includes(term));
				const inCategories = Array.isArray(icon.categories) &&
					icon.categories.some(cat => cat.toLowerCase().includes(term));
				return inName || inSearchTerms || inCategories;
			});
		}
		setSelectedIcon(null);
		setFilteredIcons(filtered);
	}, [filters]);

	const onClickOpenIconPickerModal = () => {
		setIsIconPickerOpen(true);
	}

	const onClickCloseIconPickerModal = () => {
		setFilters({
			...filters,
			selectedCategory: "all"
		});
		setIsIconPickerOpen(false);
	}

	const onClickIconCategory = (category) => {
		setFilters({
			...filters,
			selectedCategory: category
		});
	}

	const onClickSelectIcon = (icon) => {
		setSelectedIcon(icon);
	}

	const onClickUnselectIcon = (event) => {
		setSelectedIcon(null);
		event.stopPropagation();
	}

	const onClickConfirmSelectedIcon = () => {
		onSelectIcon(selectedIcon?.class ?? "");
		// setFilters({
		// 	...filters,
		// 	selectedCategory: null
		// });
		setIsIconPickerOpen(false);
	}

	const onSearchIcons = (event) => {
		const value = event.target.value;
		setFilters({
			...filters,
			searchTerm: value
		});
	}

	return (
		<>
			<div className='d-flex'>
				{selectedIcon && (
					<div className='btn btn-lighter mt-1' style={{ boxShadow: "none" }}>
						<i className={`${selectedIcon.class}`} style={{ fontSize: "1.2rem", color: "#607080" }}></i><br />
					</div>
				)}
				<div className={`d-flex mt-1 align-items-center ${selectedIcon ? "ml-2" : ""}`}>
					<button type="button" className='btn btn-sm btn-outline-primary' onClick={onClickOpenIconPickerModal}>
						{selectedIcon ? l("Cambiar%GA091") : l("Seleccionar%GA083")} {l("ícono%HP001")}
					</button>
				</div>
			</div>
			{isIconPiickerOpen && (
				<Modal
					width="900"
					height="700"
					overflow="hidden"
					onClose={onClickCloseIconPickerModal}
					filteredIcons={filteredIcons}
					searchTerm={filters?.searchTerm}
					categories={categories}
					selectedCategory={filters?.selectedCategory}
					selectedIcon={selectedIcon}
					onSearchIcons={onSearchIcons}
					onClickIconCategory={onClickIconCategory}
					onClickSelectIcon={onClickSelectIcon}
					onClickUnselectIcon={onClickUnselectIcon}
					onClickCloseIconPickerModal={onClickCloseIconPickerModal}
					onClickConfirmSelectedIcon={onClickConfirmSelectedIcon}
					component={ModalContent}
				/>
			)}
		</>
	);

}


const ModalContent = ({
	filteredIcons,
	searchTerm,
	categories,
	selectedCategory,
	selectedIcon,
	onSearchIcons,
	onClickIconCategory,
	onClickSelectIcon,
	onClickUnselectIcon,
	onClickCloseIconPickerModal,
	onClickConfirmSelectedIcon
}) => (
	<div className="card">
		<div className="card-header">
			<div className="row justify-content-between align-items-center flex-grow-1">
				<div className="col-md-2">
					<h3 className="card-header-title">Íconos</h3>
				</div>
				<div className="col-md-10">
					<div class="input-group input-group-merge input-group-flush">
						<div class="input-group-prepend">
							<div class="input-group-text">
								<i class="tio-search"></i>
							</div>
						</div>
						<input id="iconsSearch" type="search" class="form-control" value={searchTerm}
							placeholder="Buscar íconos" aria-label="Buscar íconos" onChange={onSearchIcons} />
					</div>
				</div>
			</div>

		</div>

		<div className="card-body">
			<div className="row">
				<div className="col-md-3">
					<div className='nav-icons-categories'>
						<ul class="nav flex-column">
							{categories.map((category, idx) => (
								<li class="nav-item" key={idx}>
									<a class={`nav-link icon-category ${selectedCategory == category.name ? "active" : ""}`}
										onClick={() => onClickIconCategory(category.name)}>
										<i class={`${category.icon} nav-icon mr-1`}></i> {category.label}
									</a>
								</li>
							))}
						</ul>
					</div>
				</div>

				<div className="col-md-9">
					<div className={`row icon-list ${selectedIcon ? "pt-2" : ""}`}>
						{filteredIcons.map((icon, idx) => (
							<div className="col-md-2 px-1 mb-2" key={idx}>
								<div className={`card icon-card w-100 h-100 text-center ${selectedIcon?.class == icon?.class ? "selected" : ""}`}
									onClick={() => onClickSelectIcon(icon)}>
									<div className="card-body px-1 py-3">
										<i className={`${icon.class}`}></i><br />
										<p className='text-truncate-2-lines mb-0 mt-2'>{icon.name}</p>
										{selectedIcon?.class == icon?.class && (
											<div className='fas fa-times unselect-icon' onClick={(event) => onClickUnselectIcon(event)}></div>
										)}
									</div>
								</div>
							</div>
						))}
					</div>
				</div>
			</div>
		</div>

		<div className="card-footer">
			<div className="d-flex justify-content-end">
				<button className="btn btn-sm btn-danger" onClick={onClickCloseIconPickerModal}>Cancelar</button>
				{selectedIcon && (
					<button type="button" className="btn btn-sm btn-primary ml-2" onClick={onClickConfirmSelectedIcon}>
						Seleccionar ícono
					</button>
				)}
			</div>
		</div>
	</div>
)

export default IconPicker;